import React from "react";

function BracketHeader({ bracketData, getRoundLabel, readOnly  }) {


 return (
  <div style={{ display: 'flex', gap: '2rem', justifyContent: 'center', marginBottom: 8, marginTop: 22 }}>
   {bracketData.rounds.map((round, roundIndex) => (
    <div key={roundIndex} style={{ minWidth: 200, textAlign: 'center', flex: 1, paddingBottom: '0rem' }}>
     <h3 style={{ color: readOnly ? "#fff" : "#000" }}>
      {getRoundLabel(
       roundIndex,
       bracketData.rounds.length,
       bracketData.originalTeamCount || (bracketData.rounds[0]?.length * 2)
      )}
     </h3>
    </div>
   ))}
  </div>
 );
}

export default BracketHeader;
